export default __webpack_public_path__ + "static/media/flickr.31238e1e.svg";